import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { useState, useEffect } from "react";
import MailchimpSubscribe from "react-mailchimp-subscribe";
import {motion } from "framer-motion";

const Subscribe = () => {
  const urea = "54e11197789ad63457999019e";
  const ideal = "0fdb8a7f29";
  const postUrl = `https://genhybridsystems.us11.list-manage.com/subscribe/post?u=${urea}&id=${ideal}`;

  const Form = ({ status, message, onValidated }) => {
    const [email, setEmail] = useState("");

    const submitForm = async (e) => {
      e.preventDefault();
      onValidated({
        EMAIL: email,
      });
    };

    useEffect(() => {
      status === "success" && setEmail("");
    }, [status]);

    return (
      <div className="w-3/4 md:w-2/4 mx-auto  mt-6 md:mt-10">
        <form
          onSubmit={submitForm}
          className=" relative w-full flex flex-col md:flex-row items-center gap-y-3"
        >
          <input
            required
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            className="bg-[#b9d6ff] text-black h-[3rem] border-none pl-12 w-full md:w-3/4 rounded-2xl md:rounded-tr-none md:rounded-br-none focus:outline-0 "
            type="email"
            placeholder="your email"
          />
          <FontAwesomeIcon
            className="absolute md:left-4 top-4 left-4 text-[#3282F9] "
            icon={faEnvelope}
          />
          <button
            type="submit"
            className="bg-white text-[#3282F9]  h-[3rem] w-full md:w-1/4 rounded-2xl md:rounded-tl-none md:rounded-bl-none"
          >
            Subscribe
          </button>
        </form>
        {status === "sending" && <div className="block mt-4 ">sending...</div>}
        {status === "error" && (
          <div
            className="block mt-4 "
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
        {status === "success" && (
          <div
            className="block mt-4 "
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </div>
    );
  };

  return (
    <section id="teamsection" className="section wf-section bgbluesh">
      <div className="flex flex-col justify-center items-center h-full m-auto text-center relative">
            <motion.h1 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="heading-xlarge">Subscribe</motion.h1>
        <motion.p 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }} className="text-style-all-caps">
          Stay updated with the latest&nbsp;news!
        </motion.p>
        <div className="w-form">
          <motion.form 
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ ease: "easeOut", duration: 1 }}
            id="email-form"
            name="email-form"
            data-name="Email Form"
            method="get"
          >
            <div className="form-input-wrapper contained-button wider">
              <input
                type="email"
                className="input contained-button w-node-e6203237-0698-115b-16ee-10a627b89695-e5719014 w-input"
                maxLength={256}
                name="Email"
                data-name="Email"
                placeholder="Enter your email..."
                id="Email-2"
                required=""
              />
              <div
                id="w-node-e6203237-0698-115b-16ee-10a627b89696-e5719014"
                className="contained-button"
              >
                <input
                  type="submit"
                  defaultValue="Subscribe"
                  data-wait="Please wait..."
                  className="button buttonSubscribe no-margin-top w-button buttonNew"
                />
              </div>
            </div>
          </motion.form>
          <div className="success-message w-form-done">
            <div>Thank you! Your submission has been received!</div>
          </div>
          <div className="error-message w-form-fail">
            <div>Oops! Something went wrong while submitting the form.</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Subscribe;
